import createReducer from "./createReducer";
import * as types from "@/redux/actions/types";
import { logout } from "@/utils/api.config";

const initialState = {
  isLoading: false,
  hours: {},
  userHourList: {},
  userHourListLoading: false,
  hourList: {},
  error: null,
  hourTypeSummaryList: {},
  hourTypeSummaryListLoading: false,
  hourSummary: {},
  hourLoading: false,
  approvalUserList: {},
  changeApprovalUserList: {},
  approvalDetails: {},
  approvalDetailsSimplified: {},
  approvalDetailsLoading: false,
  approvalSummary: {},
  changeDetails: {},
  changeDetailsSimplified: {},
  changeDetailsLoading: false,
  changeSummary: {},
  approvalSuccess: null,
  approvalError: null,
  addonList: {},
  addonLoading: false,
  fixedAddonList: {},
  fixedAddonLoading: false,
  userAddonList: {},
  userAddonListLoading: false,
  addonTypeSummaryList: {},
  addonTypeSummaryListLoading: false,
  fixedAddonTypeSummaryList: {},
  fixedAddonTypeSummaryListLoading: false,
  batchChangeHourList: {},
  checkInSuccess: null,
  checkInError: null,
  checkInHour: {},
  createCheckInSuccess: null,
  userAttendance: null,
  guestAttendance: null,
  lastUserAttendance: null,
  createAttendanceSuccess: null,
  attendanceSuccess: null,
  previewMultiProjectHourSuccess: null,
  previewMultiProjectHourError: null,
  // Draft batch groups state
  draftBatchGroups: [],
  draftBatchGroupData: {},
  draftBatchGroupDataError: null,
  isDraftBatchGroupData: false,
  isDraftHourSubmitting: false,
  draftHourSuccess: null,
  draftHourError: null,
  isDraftUpdateSubmitting: false,
  isCheckoutSubmitting: false,
  isDraftCheckoutSubmitting: false,
  checkoutHourSuccess: null,
  checkoutHourError: null,
  draftCheckoutHourSuccess: null,
  draftCheckoutHourError: null,
  isCreateHourSubmitting: false,
  isUpdateHourSubmitting: false,
  // v2 Batch Groups & Summary state
  batchGroups: [],
  batchGroupData: {},
  isBatchGroupData: false,
  typeSummary: {},
};

export const hourReducer = createReducer(initialState, {
  [types.GET_USERS_HOURS](state) {
    return Object.assign({}, state, {
      ...state,
      userHourListLoading: true,
      error: null,
    });
  },
  [types.GET_USERS_HOURS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      userHourList: {
        ...state.userHourList,
        [action.meta.id]: action.payload,
      },
      userHourListLoading: false,
    });
  },
  [types.GET_USERS_HOURS_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      error: action.payload,
      userHourListLoading: false,
    });
  },
  [types.GET_HOUR_TYPE_SUMMARY](state) {
    return Object.assign({}, state, {
      ...state,
      hourTypeSummaryListLoading: true,
      error: null,
    });
  },
  [types.GET_HOUR_TYPE_SUMMARY_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      hourTypeSummaryList: {
        ...state.hourTypeSummaryList,
        [action.meta.id]: action.payload,
      },
      hourTypeSummaryListLoading: false,
    });
  },
  [types.GET_HOUR_TYPE_SUMMARY_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      error: action.payload,
      hourTypeSummaryListLoading: false,
    });
  },
  [types.GET_HOURS](state) {
    return Object.assign({}, state, {
      ...state,
      hourLoading: true,
      error: null,
    });
  },
  [types.GET_HOURS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      hourList: action.payload,
      hourLoading: false,
    });
  },
  [types.GET_HOURS_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      error: action.payload,
      hourLoading: false,
    });
  },
  [types.GET_BATCH_GROUPS](state) {
    return Object.assign({}, state, {
      ...state,
      batchGroups: [],
      hourLoading: true,
      error: null,
    });
  },
  [types.GET_BATCH_GROUPS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      batchGroups: action.payload,
      hourLoading: false,
    });
  },
  [types.GET_BATCH_GROUPS_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      error: action.payload,
      hourLoading: false,
    });
  },
  [types.GET_BATCH_GROUP_DATA](state) {
    return Object.assign({}, state, {
      ...state,
      batchGroupData: {},
      isLoading: true,
      error: null,
    });
  },
  [types.GET_BATCH_GROUP_DATA_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      batchGroupData: action.payload,
      isLoading: false,
    });
  },
  [types.GET_BATCH_GROUP_DATA_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      error: action.payload,
      isLoading: false,
    });
  },
  [types.GET_BATCH_GROUP_TYPES_SUMMARY](state) {
    return Object.assign({}, state, {
      ...state,
      typeSummary: {},
      error: null,
    });
  },
  [types.GET_BATCH_GROUP_TYPES_SUMMARY_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      typeSummary: action.payload,
    });
  },
  [types.GET_BATCH_GROUP_TYPES_SUMMARY_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      error: action.payload,
    });
  },
  [types.GET_SINGLE_DAY_HOURS](state) {
    return Object.assign({}, state, {
      ...state,
      hourLoading: true,
      error: null,
    });
  },
  [types.GET_SINGLE_DAY_HOURS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      hours: action.payload,
      hourLoading: false,
    });
  },
  [types.GET_SINGLE_DAY_HOURS_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      error: action.payload,
      hourLoading: false,
    });
  },
  [types.GET_HOURS_SUMMARY](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      error: null,
    });
  },
  [types.GET_HOURS_SUMMARY_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      hourSummary: action.payload,
      isLoading: false,
    });
  },
  [types.GET_HOURS_SUMMARY_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      error: action.payload,
      isLoading: false,
    });
  },

  [types.GET_ADDONS_SUMMARY](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      error: null,
    });
  },
  [types.GET_ADDONS_SUMMARY_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      addonSummary: action.payload,
      isLoading: false,
    });
  },
  [types.GET_ADDONS_SUMMARY_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      error: action.payload,
      isLoading: false,
    });
  },
  [types.GET_APPROVAL_DETAILS](state) {
    return Object.assign({}, state, {
      approvalDetailsLoading: true,
      approvalDetails: {},
      error: null,
    });
  },
  [types.GET_APPROVAL_DETAILS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      approvalDetails: action.payload,
      approvalDetailsLoading: false,
    });
  },
  [types.GET_APPROVAL_DETAILS_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      error: action.payload,
      approvalDetailsLoading: false,
    });
  },
  [types.GET_APPROVAL_DETAILS_SIMPLIFIED](state) {
    return Object.assign({}, state, {
      approvalDetailsLoading: true,
      approvalDetailsSimplified: {},
      error: null,
    });
  },
  [types.GET_APPROVAL_DETAILS_SIMPLIFIED_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      approvalDetailsSimplified: action.payload,
      approvalDetailsLoading: false,
    });
  },
  [types.GET_APPROVAL_DETAILS_SIMPLIFIED_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      error: action.payload,
      approvalDetailsLoading: false,
    });
  },
  [types.GET_CHANGE_DETAILS](state) {
    return Object.assign({}, state, {
      changeDetailsLoading: true,
      changeDetails: {},
      error: null,
    });
  },
  [types.GET_CHANGE_DETAILS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      changeDetails: action.payload,
      changeDetailsLoading: false,
    });
  },
  [types.GET_CHANGE_DETAILS_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      error: action.payload,
      changeDetailsLoading: false,
    });
  },
  [types.GET_CHANGE_DETAILS_SIMPLIFIED](state) {
    return Object.assign({}, state, {
      changeDetailsLoading: true,
      changeDetailsSimplified: {},
      error: null,
    });
  },
  [types.GET_CHANGE_DETAILS_SIMPLIFIED_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      changeDetailsSimplified: action.payload,
      changeDetailsLoading: false,
    });
  },
  [types.GET_CHANGE_DETAILS_SIMPLIFIED_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      error: action.payload,
      changeDetailsLoading: false,
    });
  },
  [types.GET_APPROVAL_SUMMARY](state) {
    return Object.assign({}, state, {
      isLoading: true,
      approvalSummary: {},
      error: null,
    });
  },
  [types.GET_APPROVAL_SUMMARY_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      approvalSummary: action.payload,
      isLoading: false,
    });
  },
  [types.GET_APPROVAL_SUMMARY_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      error: action.payload,
      isLoading: false,
    });
  },
  [types.GET_CHANGE_SUMMARY](state) {
    return Object.assign({}, state, {
      isLoading: true,
      changeSummary: {},
      error: null,
    });
  },
  [types.GET_CHANGE_SUMMARY_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      changeSummary: action.payload,
      isLoading: false,
    });
  },
  [types.GET_CHANGE_SUMMARY_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      error: action.payload,
      isLoading: false,
    });
  },
  [types.GET_APPROVAL_USERS](state) {
    return Object.assign({}, state, {
      isLoading: true,
      approvalUserList: {},
      error: null,
    });
  },
  [types.GET_APPROVAL_USERS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      approvalUserList: action.payload,
      isLoading: false,
    });
  },
  [types.GET_APPROVAL_USERS_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      error: action.payload,
      isLoading: false,
    });
  },
  [types.GET_CHANGE_APPROVAL_USERS](state) {
    return Object.assign({}, state, {
      isLoading: true,
      changeApprovalUserList: {},
      error: null,
    });
  },
  [types.GET_CHANGE_APPROVAL_USERS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      changeApprovalUserList: action.payload,
      isLoading: false,
    });
  },
  [types.GET_CHANGE_APPROVAL_USERS_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      error: action.payload,
      isLoading: false,
    });
  },
  [types.APPROVE_HOURS](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      error: null,
      approvalSuccess: null,
      approvalError: null,
    });
  },
  [types.APPROVE_HOURS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      approvalSuccess: action.payload,
      approvalError: null,
    });
  },
  [types.APPROVE_HOURS_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      approvalError: action.payload,
      approvalSuccess: null,
      isLoading: false,
    });
  },
  [types.REJECT_HOURS](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      error: null,
      approvalSuccess: null,
      approvalError: null,
    });
  },
  [types.REJECT_HOURS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      approvalSuccess: action.payload,
      approvalError: null,
    });
  },
  [types.REJECT_HOURS_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      approvalError: action.payload,
      approvalSuccess: null,
      isLoading: false,
    });
  },
  [types.APPROVE_ALL](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      error: null,
      approvalSuccess: null,
      approvalError: null,
    });
  },
  [types.APPROVE_ALL_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      approvalSuccess: action.payload,
      approvalError: null,
    });
  },
  [types.APPROVE_ALL_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      approvalError: action.payload,
      approvalSuccess: null,
      isLoading: false,
    });
  },
  [types.REJECT_ALL](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      error: null,
      approvalSuccess: null,
      approvalError: null,
    });
  },
  [types.REJECT_ALL_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      approvalSuccess: action.payload,
      approvalError: null,
    });
  },
  [types.REJECT_ALL_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      approvalError: action.payload,
      approvalSuccess: null,
      isLoading: false,
    });
  },
  [types.APPROVE_CHANGE_ALL](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      error: null,
      approvalSuccess: null,
      approvalError: null,
    });
  },
  [types.APPROVE_CHANGE_ALL_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      approvalSuccess: action.payload,
      approvalError: null,
    });
  },
  [types.APPROVE_CHANGE_ALL_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      approvalError: action.payload,
      approvalSuccess: null,
      isLoading: false,
    });
  },
  [types.CHANGE_HOURS](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      error: null,
      approvalSuccess: null,
      approvalError: null,
    });
  },
  [types.CHANGE_HOURS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      approvalSuccess: action.payload,
      approvalError: null,
    });
  },
  [types.CHANGE_HOURS_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      approvalError: action.payload,
      approvalSuccess: null,
      isLoading: false,
    });
  },
  [types.APPROVE_ADDONS](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      error: null,
      approvalSuccess: null,
      approvalError: null,
    });
  },
  [types.APPROVE_ADDONS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      approvalSuccess: action.payload,
      approvalError: null,
    });
  },
  [types.APPROVE_ADDONS_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      approvalError: action.payload,
      approvalSuccess: null,
      isLoading: false,
    });
  },
  [types.REJECT_ADDONS](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      error: null,
      approvalSuccess: null,
      approvalError: null,
    });
  },
  [types.REJECT_ADDONS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      approvalSuccess: action.payload,
      approvalError: null,
    });
  },
  [types.REJECT_ADDONS_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      approvalError: action.payload,
      approvalSuccess: null,
      isLoading: false,
    });
  },
  [types.CHANGE_ADDONS](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      error: null,
      approvalSuccess: null,
      approvalError: null,
    });
  },
  [types.CHANGE_ADDONS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      approvalSuccess: action.payload,
      approvalError: null,
    });
  },
  [types.CHANGE_ADDONS_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      approvalError: action.payload,
      approvalSuccess: null,
      isLoading: false,
    });
  },
  [types.GET_ADDONS](state) {
    return Object.assign({}, state, {
      ...state,
      addonLoading: true,
      error: null,
    });
  },
  [types.GET_ADDONS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      addonList: action.payload,
      addonLoading: false,
    });
  },
  [types.GET_ADDONS_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      error: action.payload,
      addonLoading: false,
    });
  },

  [types.GET_USERS_ADDONS](state) {
    return Object.assign({}, state, {
      ...state,
      userAddonListLoading: true,
      error: null,
    });
  },
  [types.GET_USERS_ADDONS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      userAddonList: {
        ...state.userAddonList,
        [action.meta.id]: action.payload,
      },
      userAddonListLoading: false,
    });
  },
  [types.GET_USERS_ADDONS_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      error: action.payload,
      userAddonListLoading: false,
    });
  },
  [types.GET_ADDON_TYPE_SUMMARY](state) {
    return Object.assign({}, state, {
      ...state,
      addonTypeSummaryListLoading: true,
      error: null,
    });
  },
  [types.GET_ADDON_TYPE_SUMMARY_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      addonTypeSummaryList: {
        ...state.addonTypeSummaryList,
        [action.meta.id]: action.payload,
      },
      addonTypeSummaryListLoading: false,
    });
  },
  [types.GET_ADDON_TYPE_SUMMARY_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      error: action.payload,
      addonTypeSummaryListLoading: false,
    });
  },
  [types.GET_FIXED_ADDON_TYPE_SUMMARY](state) {
    return Object.assign({}, state, {
      ...state,
      fixedAddonTypeSummaryListLoading: true,
      error: null,
    });
  },
  [types.GET_FIXED_ADDON_TYPE_SUMMARY_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      fixedAddonTypeSummaryList: {
        ...state.fixedAddonTypeSummaryList,
        [action.meta.id]: action.payload,
      },
      fixedAddonTypeSummaryListLoading: false,
    });
  },
  [types.GET_FIXED_ADDON_TYPE_SUMMARY_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      error: action.payload,
      fixedAddonTypeSummaryListLoading: false,
    });
  },
  [types.APPROVE_BATCH](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      error: null,
      approvalSuccess: null,
      approvalError: null,
    });
  },
  [types.APPROVE_BATCH_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      approvalSuccess: action.payload,
      approvalError: null,
    });
  },
  [types.APPROVE_BATCH_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      approvalError: action.payload,
      approvalSuccess: null,
      isLoading: false,
    });
  },
  [types.REJECT_BATCH](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      error: null,
      approvalSuccess: null,
      approvalError: null,
    });
  },
  [types.REJECT_BATCH_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      approvalSuccess: action.payload,
      approvalError: null,
    });
  },
  [types.REJECT_BATCH_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      approvalError: action.payload,
      approvalSuccess: null,
      isLoading: false,
    });
  },
  [types.GET_BATCH_RULES](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      batchChangeHourList: {},
      error: null,
    });
  },
  [types.GET_BATCH_RULES_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      batchChangeHourList: action.payload,
      isLoading: false,
    });
  },
  [types.GET_BATCH_RULES_FAILURE](state, action) {
    return Object.assign({}, state, {
      ...initialState,
      error: action.payload,
      isLoading: false,
    });
  },
  [types.CHANGE_BATCH](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      error: null,
      approvalSuccess: null,
      approvalError: null,
    });
  },
  [types.CHANGE_BATCH_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      approvalSuccess: action.payload,
      approvalError: null,
    });
  },
  [types.CHANGE_BATCH_FAILURE](state, action) {
    return Object.assign({}, state, {
      ...initialState,
      approvalError: action.payload,
      approvalSuccess: null,
      isLoading: false,
    });
  },
  [types.GET_CHECKIN_HOUR](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      checkInHour: {},
      checkInError: null,
    });
  },
  [types.GET_CHECKIN_HOUR_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      checkInHour: action.payload,
      isLoading: false,
    });
  },
  [types.GET_CHECKIN_HOUR_FAILURE](state, action) {
    return Object.assign({}, state, {
      ...state,
      checkInError: action.payload,
      isLoading: false,
    });
  },
  [types.CREATE_CHECKIN_HOUR](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      checkInError: null,
      checkInSuccess: null,
      createCheckInSuccess: null,
    });
  },
  [types.CREATE_CHECKIN_HOUR_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      createCheckInSuccess: action.payload,
      checkInError: null,
    });
  },
  [types.CREATE_CHECKIN_HOUR_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      checkInError: action.payload,
      createCheckInSuccess: null,
      isLoading: false,
    });
  },
  [types.UPDATE_CHECKIN_HOUR](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      checkInError: null,
      checkInSuccess: null,
    });
  },
  [types.UPDATE_CHECKIN_HOUR_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      checkInSuccess: action.payload,
      checkInError: null,
    });
  },
  [types.UPDATE_CHECKIN_HOUR_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      checkInError: action.payload,
      checkInSuccess: null,
      isLoading: false,
    });
  },
  [types.DELETE_CHECKIN_HOUR](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      checkInError: null,
      checkInSuccess: null,
    });
  },
  [types.DELETE_CHECKIN_HOUR_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      checkInSuccess: action.payload,
      checkInError: null,
    });
  },
  [types.DELETE_CHECKIN_HOUR_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      checkInError: action.payload,
      checkInSuccess: null,
      isLoading: false,
    });
  },
  [types.APPROVE_BATCH_GROUP](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      error: null,
      approvalSuccess: null,
      approvalError: null,
    });
  },
  [types.APPROVE_BATCH_GROUP_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      approvalSuccess: action.payload,
      approvalError: null,
    });
  },
  [types.APPROVE_BATCH_GROUP_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      approvalError: action.payload,
      approvalSuccess: null,
      isLoading: false,
    });
  },
  [types.REJECT_BATCH_GROUP](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      error: null,
      approvalSuccess: null,
      approvalError: null,
    });
  },
  [types.REJECT_BATCH_GROUP_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      approvalSuccess: action.payload,
      approvalError: null,
    });
  },
  [types.REJECT_BATCH_GROUP_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      approvalError: action.payload,
      approvalSuccess: null,
      isLoading: false,
    });
  },
  [types.CHANGE_BATCH_GROUP](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      error: null,
      approvalSuccess: null,
      approvalError: null,
    });
  },
  [types.CHANGE_BATCH_GROUP_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      approvalSuccess: action.payload,
      approvalError: null,
    });
  },
  [types.CHANGE_BATCH_GROUP_FAILURE](state, action) {
    return Object.assign({}, state, {
      ...initialState,
      approvalError: action.payload,
      approvalSuccess: null,
      isLoading: false,
    });
  },
  [types.GET_USER_ATTENDANCE](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      userAttendance: null,
      attendanceError: null,
    });
  },
  [types.GET_USER_ATTENDANCE_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      userAttendance: action.payload,
      isLoading: false,
    });
  },
  [types.GET_USER_ATTENDANCE_FAILURE](state, action) {
    return Object.assign({}, state, {
      ...initialState,
      attendanceError: action.payload,
      isLoading: false,
    });
  },
  [types.GET_GUEST_ATTENDANCE](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      guestAttendance: null,
      attendanceError: null,
    });
  },
  [types.GET_GUEST_ATTENDANCE_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      guestAttendance: action.payload,
      isLoading: false,
    });
  },
  [types.GET_GUEST_ATTENDANCE_FAILURE](state, action) {
    return Object.assign({}, state, {
      ...initialState,
      attendanceError: action.payload,
      isLoading: false,
    });
  },
  [types.CREATE_USER_ATTENDANCE](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      attendanceError: null,
      attendanceSuccess: null,
      createAttendanceSuccess: null,
    });
  },
  [types.CREATE_USER_ATTENDANCE_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      createAttendanceSuccess: action.payload,
      attendanceError: null,
    });
  },
  [types.CREATE_USER_ATTENDANCE_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      attendanceError: action.payload,
      createAttendanceSuccess: null,
      isLoading: false,
    });
  },
  [types.UPDATE_USER_ATTENDANCE](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      attendanceError: null,
      attendanceSuccess: null,
    });
  },
  [types.UPDATE_USER_ATTENDANCE_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      attendanceSuccess: action.payload,
      attendanceError: null,
    });
  },
  [types.UPDATE_USER_ATTENDANCE_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      attendanceError: action.payload,
      attendanceSuccess: null,
      isLoading: false,
    });
  },
  [types.CREATE_MULTI_PROJECT_HOURS](state) {
    return Object.assign({}, state, {
      ...state,
      isCreateHourSubmitting: true,
      isLoading: true,
      error: null,
      multiProjectHourSuccess: null,
      multiProjectHourError: null,
    });
  },
  [types.CREATE_MULTI_PROJECT_HOURS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isCreateHourSubmitting: false,
      isLoading: false,
      multiProjectHourSuccess: action.payload,
      multiProjectHourError: null,
    });
  },
  [types.CREATE_MULTI_PROJECT_HOURS_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      multiProjectHourError: action.payload,
      multiProjectHourSuccess: null,
      isCreateHourSubmitting: false,
      isLoading: false,
    });
  },
  [types.UPDATE_BATCH_GROUP](state) {
    return Object.assign({}, state, {
      ...state,
      isUpdateHourSubmitting: true,
      isLoading: true,
      error: null,
      multiProjectHourSuccess: null,
      multiProjectHourError: null,
    });
  },
  [types.UPDATE_BATCH_GROUP_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isUpdateHourSubmitting: false,
      isLoading: false,
      multiProjectHourSuccess: action.payload,
      multiProjectHourError: null,
    });
  },
  [types.UPDATE_BATCH_GROUP_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      multiProjectHourError: action.payload,
      multiProjectHourSuccess: null,
      isUpdateHourSubmitting: false,
      isLoading: false,
    });
  },
  [types.DELETE_BATCH_GROUP](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      error: null,
      multiProjectHourSuccess: null,
      multiProjectHourError: null,
    });
  },
  [types.DELETE_BATCH_GROUP_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      multiProjectHourSuccess: action.payload,
      multiProjectHourError: null,
    });
  },
  [types.DELETE_BATCH_GROUP_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      multiProjectHourError: action.payload,
      multiProjectHourSuccess: null,
      isLoading: false,
    });
  },
  [types.GET_USER_ATTENDANCE_LAST](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      lastUserAttendance: null,
      attendanceError: null,
    });
  },
  [types.GET_USER_ATTENDANCE_LAST_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      lastUserAttendance: action.payload,
      isLoading: false,
    });
  },
  [types.GET_USER_ATTENDANCE_LAST_FAILURE](state, action) {
    return Object.assign({}, state, {
      ...state,
      attendanceError: action.payload,
      isLoading: false,
    });
  },
  [types.PREVIEW_MULTI_PROJECT_HOURS](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      error: null,
      previewMultiProjectHourSuccess: null,
      previewMultiProjectHourError: null,
    });
  },
  [types.PREVIEW_MULTI_PROJECT_HOURS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      previewMultiProjectHourSuccess: action.payload,
    });
  },
  [types.PREVIEW_MULTI_PROJECT_HOURS_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      previewMultiProjectHourError: action.payload,
      isLoading: false,
    });
  },
  [types.CREATE_CHECKOUT_HOUR](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      isCheckoutSubmitting: true,
      error: null,
      checkoutHourSuccess: null,
      checkoutHourError: null,
    });
  },
  [types.CREATE_CHECKOUT_HOUR_SUCCESS](state, action) {
    let payload = action.payload;
    if (payload && typeof payload === "object") {
      let checkIns = payload.check_ins;
      if (!checkIns && Array.isArray(payload.entries)) {
        checkIns = payload.entries;
      } else if (!checkIns && Array.isArray(payload.data)) {
        checkIns = payload.data;
      }
      if (checkIns) {
        payload = {
          ...payload,
          check_ins: checkIns,
        };
      }
    }
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      isCheckoutSubmitting: false,
      checkoutHourSuccess: payload,
      checkoutHourError: null,
    });
  },
  [types.CREATE_CHECKOUT_HOUR_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      checkoutHourError: action.payload,
      checkoutHourSuccess: null,
      isCheckoutSubmitting: false,
      isLoading: false,
    });
  },
  [types.CREATE_DRAFT_CHECKOUT_HOUR](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      isDraftCheckoutSubmitting: true,
      error: null,
      draftCheckoutHourSuccess: null,
      draftCheckoutHourError: null,
    });
  },
  [types.CREATE_DRAFT_CHECKOUT_HOUR_SUCCESS](state, action) {
    let payload = action.payload;
    if (payload && typeof payload === "object") {
      let draftCheckIns = payload.draft_check_ins;
      if (!draftCheckIns && Array.isArray(payload.entries)) {
        draftCheckIns = payload.entries;
      } else if (!draftCheckIns && Array.isArray(payload.data)) {
        draftCheckIns = payload.data;
      }
      if (draftCheckIns) {
        payload = {
          ...payload,
          draft_check_ins: draftCheckIns,
        };
      }
    }
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      isDraftCheckoutSubmitting: false,
      draftCheckoutHourSuccess: payload,
      draftCheckoutHourError: null,
    });
  },
  [types.CREATE_DRAFT_CHECKOUT_HOUR_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      draftCheckoutHourError: action.payload,
      draftCheckoutHourSuccess: null,
      isDraftCheckoutSubmitting: false,
      isLoading: false,
    });
  },
  [types.GET_FIXED_ADDONS](state) {
    return Object.assign({}, state, {
      ...state,
      fixedAddonLoading: true,
      error: null,
    });
  },
  [types.GET_FIXED_ADDONS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      fixedAddonList: action.payload,
      fixedAddonLoading: false,
    });
  },
  [types.GET_FIXED_ADDONS_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      error: action.payload,
      fixedAddonLoading: false,
    });
  },

  // ── Draft Hours ───────────────────────────────────────────────────────────
  [types.CREATE_DRAFT_HOURS](state) {
    return Object.assign({}, state, {
      ...state,
      isDraftHourSubmitting: true,
      draftHourSuccess: null,
      draftHourError: null,
    });
  },
  [types.CREATE_DRAFT_HOURS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isDraftHourSubmitting: false,
      draftHourSuccess: action.payload,
      draftHourError: null,
    });
  },
  [types.CREATE_DRAFT_HOURS_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      draftHourError: action.payload,
      draftHourSuccess: null,
      isDraftHourSubmitting: false,
    });
  },

  // ── Draft Batch Groups ────────────────────────────────────────────────────
  [types.GET_DRAFT_BATCH_GROUPS](state) {
    return Object.assign({}, state, {
      ...state,
      draftBatchGroups: [],
    });
  },
  [types.GET_DRAFT_BATCH_GROUPS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      draftBatchGroups: action.payload,
    });
  },
  [types.GET_DRAFT_BATCH_GROUPS_FAILURE](state) {
    return Object.assign({}, state, {
      ...state,
      draftBatchGroups: [],
    });
  },
  [types.GET_DRAFT_BATCH_GROUP_DATA](state) {
    return Object.assign({}, state, {
      ...state,
      draftBatchGroupData: {},
      draftBatchGroupDataError: null,
      isDraftBatchGroupData: false,
    });
  },
  [types.GET_DRAFT_BATCH_GROUP_DATA_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      draftBatchGroupData: action.payload,
      draftBatchGroupDataError: null,
      isDraftBatchGroupData: true,
    });
  },
  [types.GET_DRAFT_BATCH_GROUP_DATA_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      draftBatchGroupData: {},
      draftBatchGroupDataError: action.payload,
      error: action.payload,
      isDraftBatchGroupData: true, // set true so promise resolvers don't hang
    });
  },
  [types.UPDATE_DRAFT_BATCH_GROUP](state) {
    return Object.assign({}, state, {
      ...state,
      isDraftUpdateSubmitting: true,
      draftHourSuccess: null,
      draftHourError: null,
    });
  },
  [types.UPDATE_DRAFT_BATCH_GROUP_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isDraftUpdateSubmitting: false,
      draftHourSuccess: action.payload,
      draftHourError: null,
    });
  },
  [types.UPDATE_DRAFT_BATCH_GROUP_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      isDraftUpdateSubmitting: false,
      draftHourError: action.payload,
      draftHourSuccess: null,
    });
  },
  [types.DELETE_DRAFT_BATCH_GROUP](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      error: null,
      draftHourSuccess: null,
      draftHourError: null,
    });
  },
  [types.DELETE_DRAFT_BATCH_GROUP_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      draftHourSuccess: action.payload,
      draftHourError: null,
    });
  },
  [types.DELETE_DRAFT_BATCH_GROUP_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      draftHourError: action.payload,
      draftHourSuccess: null,
    });
  },
});
